import { getLocalApi } from "./localApi";
import { AddonType } from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllAddonTypes() : Promise<AddonType[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_addon_types, (dto:any) => ({
        name: dto.name,
        id: Number(dto.id)
    }), 'Unable to fetch addon types');
}

